<template>
    <div>
        <h4 class="title">◈ {{ title }} ◈</h4>
    </div>
</template>

<script>
export default {
    props: [ "title" ],
}
</script>

<style lang="less" scoped>
.title {
    font-size: 22px;
    font-weight: 500;
    line-height: 30px;
}
</style>